<template>
  <div class="ckeditor">
    <label>{{ label }} <span v-if="required" class="required">*</span></label>
    <ckeditor
      :editor="editor"
      v-model="value"
      :config="editorConfig"
    ></ckeditor>
  </div>
</template>

<script>
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import UploadAdapter from "../utilities/uploadAdapter";
export default {
  name: "CKEditor",
  components: {
    ckeditor: CKEditor.component,
  },
  props: ["label", "value", "required"],
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        extraPlugins: [this.uploader],
      },
    };
  },
  methods: {
    uploader(editor) {
      editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
        return new UploadAdapter(loader);
      };
    },
  },
  watch: {
    value($event) {
      this.$emit("input", $event);
    },
  },
};
</script>

<style>
.ckeditor {
  width: 400px;
  margin: 0 auto;
}
.ck.ck-label {
  display: none !important;
}
.question .ck.ck-dropdown {
  display: none !important;
}

.question .ck.ck-editor .ck-editor__top .ck-sticky-panel .ck-toolbar {
  padding: 0;
}

.question
  .ck.ck-editor
  .ck-editor__top
  .ck-sticky-panel
  .ck-toolbar
  .ck-button:nth-child(5),
.question
  .ck.ck-editor
  .ck-editor__top
  .ck-sticky-panel
  .ck-toolbar
  .ck-button:nth-child(8),
.question
  .ck.ck-editor
  .ck-editor__top
  .ck-sticky-panel
  .ck-toolbar
  .ck-button:nth-child(9) {
  display: none !important;
}
</style>
